<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <section class="md:tw-w-1/3 tw-px-1">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-information tw-ml-2"></i>
              {{ "common.specifications" | translate }}
            </legend>

            <div class="row">
              <!-- name -->
              <div class="tw-w-full">
                <form-field
                  [(value)]="model.name"
                  [control]="form?.get('name')"
                  label="common.name"
                >
                </form-field>
              </div>
              <!-- custom-fields -->
              <div class="tw-w-full">
                <organization-custom-field-select-search
                  [removable]="false"
                  [isDeleteAfterEmit]="true"
                  (itemChange)="addCustomField($event)"
                  [control]="form?.get('customFields')"
                  (onError)="onClose()"
                >
                </organization-custom-field-select-search>
              </div>
              <!-- text -->
              <div class="tw-w-full">
                <!-- TODO textarea torbatian -->
                <mat-form-field
                  appearance="outline"
                  class="tw-w-full tw-relative"
                >
                  <mat-label>
                    {{ fields + "customText" | translate }}
                  </mat-label>

                  <textarea
                    #customText
                    matInput
                    [(ngModel)]="customText"
                    (ngModelChange)="customText = $event"
                    formControlName="customText"
                    class="tw-text-lg font-vazir-ui"
                    rows="10"
                    spellcheck="false"
                    autocomplete="off"
                  >
                  </textarea>

                  <!-- Guide -->
                  <div
                    class="tw-cursor-pointer tw-absolute add-new-text"
                    (click)="addCustomText()"
                  >
                    <i
                      [matTooltip]="'common.add' | translate"
                      class="mdi mdi-plus-circle text-navyBlue mdi-24px tw-absolute"
                      style="left: 0"
                    ></i>
                  </div>
                  <div class="tw-cursor-pointer tw-absolute add-emoji">
                    <!-- emoji -->
                    <emoji-picker
                      class="tw-my-[4px]"
                      (emoji)="addEmojiToMessage($event)"
                    >
                    </emoji-picker>
                  </div>
                </mat-form-field>
              </div>
            </div>
          </fieldset>
        </section>

        <section class="md:tw-w-2/3 tw-px-1">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-card-bulleted-settings tw-ml-2"></i>
              {{ "common.createTemplate" | translate }}
            </legend>

            <div class="tw-flex-center">
              <div style="flex: 1">
                <div class="alert alert-light border">
                  <p
                    class="tw-font-extrabold tw-text-[14px] tw-mb-4 text-danger"
                  >
                    {{ pageVocabs + "messages.note1" | translate }}
                  </p>
                  <p class="tw-font-medium tw-mb-2 dark:tw-text-gray-200">
                    ◍
                    {{ pageVocabs + "messages.note2" | translate }}
                  </p>
                  <p class="tw-font-medium tw-mb-2 dark:tw-text-gray-200">
                    ◍
                    {{ pageVocabs + "messages.note3" | translate }}
                  </p>
                </div>

                <div cdkDropListGroup>
                  <!-- contactFieldList -->
                  <div style="display: flex; flex-wrap: wrap" class="tw-my-3">
                    <div
                      (click)="addContactField(item)"
                      *ngFor="let item of contactFieldList; let index = index"
                      class="word contact-field-word"
                      style="cursor: pointer"
                      [matTooltip]="'common.add' | translate"
                    >
                      <div>
                        {{ item.title }}
                      </div>
                    </div>
                  </div>

                  <!-- wordList -->
                  <div class="words-box tw-mb-5">
                    <div class="tw-mb-3">
                      <a class="text-danger tw-mb-2" (click)="clearWordList()">
                        <i
                          [matTooltip]="'common.removeAll' | translate"
                          class="mdi text-danger tw-mb-1 mdi-trash-can-outline mdi-20px tw-cursor-pointer"
                        ></i>
                      </a>
                    </div>
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        cdkDropList
                        class="word"
                        [cdkDropListData]="index"
                        *ngFor="let item of wordList; let index = index"
                      >
                        <div
                          class="tw-flex tw-justify-between tw-items-center"
                          cdkDrag
                          [cdkDragData]="index"
                          (cdkDragEntered)="entered($event)"
                          [id]="'cdkDragItem' + index"
                          [class.contact-field-word]="item.type === 0"
                          [class.custom-field-word]="item.type === 1"
                          [class.custom-text-word]="item.type === 2"
                          style="
                            overflow: hidden;
                            height: 100%;
                            border-radius: 5px;
                          "
                        >
                          <span style="overflow: hidden; height: 100%">
                            {{ item.title }}</span
                          >
                          <i
                            [matTooltip]="'common.delete' | translate"
                            (click)="removeItemFromWordList(index)"
                            class="mdi mdi-close text-danger tw-mx-2 tw-cursor-pointer"
                          ></i>

                          <!--hidden Placeholder -->
                          <span
                            class="tw-flex tw-justify-between tw-items-center"
                            *cdkDragPlaceholder
                          >
                            <i
                              class="mdi mdi-close text-danger tw-mx-2 tw-cursor-pointer d-none"
                            ></i>
                            <span class="d-none"> {{ item.title }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="description" *ngIf="wordList?.length == 0">
                      {{ pageVocabs + "messages.description1" | translate }}
                      <br />
                      {{ pageVocabs + "messages.description2" | translate }}
                    </div>
                  </div>
                </div>

                <!-- format -->
                <div>
                  <mat-form-field appearance="outline" class="tw-w-full">
                    <mat-label>{{ fields + "format" | translate }}</mat-label>
                    <textarea
                      matInput
                      formControlName="format"
                      class="tw-text-lg"
                      rows="3"
                      [(ngModel)]="faFormat"
                      readonly
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </fieldset>
        </section>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
